<!-- <mat-sidenav-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
    <mat-sidenav #sidenav mode="side" opened>
        <mat-nav-list>
            <a mat-list-item style="height: 30px;" [ngStyle]="{'font-weight': openUpdateMetadata ? 'bold' : 'normal' }" (click)="updateMetadata()">Update Metadata</a>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
        <div *ngIf="openUpdateMetadata">
            <app-bulk-update-metadata></app-bulk-update-metadata>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container> -->

<app-bulk-update-metadata></app-bulk-update-metadata>